import gql from 'graphql-tag';

export const AvailableLanguages = gql`
  query availableLanguages {
    availableLanguages {
      locale
      language
      short
    }
  }
`;

export const PlatformFlags = gql`
  query platformFlags {
    platform {
      name
      isContentProtected
      canAnswerSurveyQuestions
      canUseMediaInStepHints
      sso
      isDispatchSso
      ssoProviders {
        id
        label
        provider
      }
      hasMultiDomainEnabled
      hasFeedbackEnabled
      hasChecklistsEnabled
      hasChecklistsSignatureEnabled
      checklistExtraFieldLabel
      hasChecklistEscalation
      hasDispatchEnabled
      hasApiAccess
      hasRever
      maxVideoUploadMb
      domain {
        loginOptions
        hasDispatchSite
      }
    }
  }
`;

export const Platform = gql`
  query platform {
    platform {
      id
      name
      subdomain
      assetsFolder
      showStepNoteIconLabel
      defaultDomain {
        slug
      }
      domain {
        id
        name
        slug
        loginOptions
        theme {
          name
          logoUrl
          faviconUrl
          mainColor
          buttonColor
          fontFamily
          tipIcon
          warningIcon
          alternativeIcon
          fixIcon
          showHintLabels
          customFontRegularUrl
          customFontBoldUrl
          customFontItalicUrl
          customFontBoldItalicUrl
          customFontFallback
          icons {
            id
            svg
            labelTranslations
            isEnabled
            type
          }
        }
      }
      organization {
        id
        theme {
          name
          logoUrl
          faviconUrl
          mainColor
          buttonColor
          fontFamily
          tipIcon
          warningIcon
          alternativeIcon
          fixIcon
          showHintLabels
          customFontRegularUrl
          customFontBoldUrl
          customFontItalicUrl
          customFontBoldItalicUrl
          customFontFallback
          icons {
            id
            svg
            labelTranslations
            isEnabled
            type
          }
        }
      }
    }
  }
`;
